import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["input", "counter"]

  connect() {
    this.update()
  }

  update() {
    this.counterTarget.textContent =
      `(${this.inputTarget.value.length} / ${this.inputTarget.maxLength})`
  }
}